import React from 'react';
import { useIsMobile } from '../../utils/useIsMobile';

export default function Header({
  title,
  subtitle,
  filters,
  padding = { x: 'tw-px-[32px]', y: 'tw-py-[16px]' },
  page,
}) {
  const isMobile = useIsMobile();

  return (
    <div
      className={`tw-flex tw-justify-center tw-w-full ${padding.y} ${
        isMobile ? 'tw-px-[12px] tw-pt-7' : `${padding.x}`
      } tw-bg-[#EBECF0] tw-border-0 tw-border-b tw-border-solid tw-border-border-primary-strong`}
    >
      <div
        className={`tw-flex ${
          isMobile ? 'tw-flex-col tw-gap-3' : 'tw-flex-row tw-gap-0 tw-justify-between tw-items-center'
        } tw-grow tw-bg-background ${
          page !== 'Dashboard' && !isMobile ? 'tw-max-w-[1320px]' : ''
        } tw-w-full`}
      >
        <div className={`tw-flex tw-flex-col tw-gap-1 tw-min-w-0 ${isMobile ? 'tw-items-end' : ''}`}>
          <h1 className={`m-0 relative tw-tracking-[-0.02em] tw-font-semibold ${
            isMobile ? 'tw-text-[18px] tw-leading-[18px]' : 'tw-text-[22px] tw-leading-[22px]'
          } tw-break-words`}>
            {title}
          </h1>
          <span
            className={`tw-tracking-[-0.02em] ${isMobile ? 'tw-text-right' : ''} tw-font-semibold tw-font-work tw-text-text-dark-medium-importance tw-text-xs tw-leading-[12px] tw-ellipsis`}
          >
            {subtitle}
          </span>
        </div>
        <div className={`tw-flex ${
          isMobile ? 'tw-gap-2 tw-flex-wrap tw-w-full tw-justify-end' : 'tw-gap-3 tw-flex-nowrap tw-w-auto'
        } tw-items-center`}>
          {filters}
        </div>
      </div>
    </div>
  );
}
